import { render, staticRenderFns } from "./HomeLoading.vue?vue&type=template&id=2c31d6b0&"
import script from "./HomeLoading.vue?vue&type=script&lang=js&"
export * from "./HomeLoading.vue?vue&type=script&lang=js&"
import style0 from "./HomeLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports